"use client";

import { useState } from "react";
import Link from "next/link";
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import { YellowSideMenuItem } from "@/@types/ui/YellowSideMenu";

// Props
type Props = {
  menuItems: YellowSideMenuItem[];
  activeItem: string;
  activeSubItem?: string; // Slug del subítem activo
};

export default function MobileMenu({
  menuItems,
  activeItem,
  activeSubItem,
}: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="block bg-gray-200 relative z-10 border border-gray-300 lg:hidden">
      {/* Botón principal para abrir/cerrar el menú */}
      <button
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className="flex justify-between items-center w-full px-4 py-2 text-lg font-bold uppercase text-black"
      >
        Categorías
        <span>
          {isMenuOpen ? (
            <ChevronDownIcon className="h-5 w-5 text-black" />
          ) : (
            <ChevronRightIcon className="h-5 w-5 text-black" />
          )}
        </span>
      </button>

      {/* Contenido del menú desplegable */}
      {isMenuOpen && (
        <ul className="divide-y divide-gray-200 bg-white">
          {menuItems.map((item) => (
            <li key={item.id} className="group">
              {/* Título del padre */}
              <Link href={item.href || "#"}>
                <h2
                  className={`text-sm font-bold uppercase px-4 py-2 ${
                    activeItem === item.id ? "bg-yellow-400 text-black" : "bg-[#f5f5f5]"
                  }`}
                >
                  {item.title}
                </h2>
              </Link>

              {/* Subitems del padre */}
              <ul className="space-y-2 text-sm text-gray-800">
                {item.children?.map((child) => (
                  <li key={child.id}>
                    <Link
                      href={child.href || "#"}
                      className={`block px-4 py-1 ${
                        activeSubItem === child.id
                          ? "text-yellow-500"
                          : "text-gray-800"
                      } hover:text-yellow-500`}
                    >
                      {child.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
